/**
 * Featured Card Block - CellarPass Functionality
 */

 export default function HWY_CellarPass() {

	const selectors = {
		reserveBtn: ".cellarpass-button"
	};

	this.init = () => {
        jQuery(selectors.reserveBtn).on("click", function(e) {
            let eventID = jQuery(this).attr('data-eventid');
            console.log(eventID);

            //jQuery('#cellarpass-widget').data('url', 'mid=644&eventid=' + eventID);
            jQuery('.cellarpass-content iframe').attr('src', 'https://www.cellarpass.com/widget?mid=664&eventid=' + eventID + '&sh=false');
            
        });

	};
}